import React from 'react'
import ReactDOM from 'react-dom/client'
import 'dayjs/locale/zh-cn'
import App from './App'
import './styles/design-tokens.css'
import './styles/global.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
